import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { IMPERSONATION_HEADER } from '@vasta/frontend-shared-core-authentication';
import { ImpersonationService } from '../impersonation.service';
import { isApiRequest } from './api-request';

/**
 * Asks the API to answer as the user this tab was handed off to. The header is
 * a request, not a grant: without the permission behind it the API refuses and
 * `unauthorizedInterceptor` drops the state.
 */
export const impersonationInterceptor: HttpInterceptorFn = (req, next) => {
  const targetId = inject(ImpersonationService).targetId();
  if (targetId === null) return next(req);

  if (!isApiRequest(req)) return next(req);

  return next(
    req.clone({ setHeaders: { [IMPERSONATION_HEADER]: String(targetId) } }),
  );
};
